import { AxiosInstance } from 'axios';
import { Request } from '@/shared/module/Request';

export class RequestFactory {
  constructor(private axiosInstance: AxiosInstance) {
  }

  requestOfGet(url: string, params?: any, body?: any) {
    return new Request(
      this.axiosInstance,
      'get',
      url,
      params,
      body,
    );
  }
}
